import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { useTaktId, createStormTaktId, Text } from '@amzn/storm-ui';
import { u as useFormStage } from './hooks/useStage-C5gC2haD.js';
import { I as IntroText, M as MobileShareButton } from './FormLayout.styles-BzYy_4z2.js';

const FormLayoutMobileIntro = ({
  mobileShareButtonLabel = 'Share feedback',
  renderHeader,
  renderIntro
}) => {
  const {
    onIntroVisited
  } = useFormStage();
  const {
    getDataTaktAttributes: getShareButtonDataTaktAttributes
  } = useTaktId({
    fallbackId: createStormTaktId('form-layout-mobile-intro-share-button')
  });
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Text, {
    type: "h5"
  }, typeof renderHeader === 'function' ? renderHeader() : renderHeader), /*#__PURE__*/React__default.createElement(IntroText, {
    fontSize: "mini",
    textColor: "tertiary"
  }, typeof renderIntro === 'function' ? renderIntro() : renderIntro), /*#__PURE__*/React__default.createElement(MobileShareButton, _extends({
    onClick: () => {
      onIntroVisited();
    }
  }, getShareButtonDataTaktAttributes()), mobileShareButtonLabel));
};

export { FormLayoutMobileIntro as F };
//# sourceMappingURL=FormLayoutMobileIntro-BZRibC1Y.js.map
